import ChecklistService from "../../services/ChecklistService";

class ChecklistDetailsManager {
  async getChecklistById(checklistId) {
    return ChecklistService.getChecklistById(checklistId).then(answer => answer && answer.data);
  }
}

export default new ChecklistDetailsManager();
